export enum NavigationItemTypeEnum {
    App = "App",
    ItemLink = "ItemLink",
    Logout = "Logout",
    Signup = "Signup",
    DashboardMenu = "DashboardMenu",
}